import Vue from "vue";
import SongService from "@/services/Song";

const state = {
  tags: {}
};

const getters = {
  tag: ({ tags }) => tag => tags[tag]
};

const mutations = {
  SET_TAG({ tags }, data) {
    Vue.set(tags, data.tag, data);
  }
};

const actions = {
  async fetchFeaturedTag({ commit }, tag) {
    const res = await SongService.getTagHeader({ tag });
    if (res.status === 200 && res.data?.id) {
      commit("SET_TAG", res.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
